import { authLoginPathForTarget } from '../../shared/authLoginTargets';

function resolveBaseURL(homeHref) {
  const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  return new URL(String(homeHref || '/'), fallbackOrigin);
}

function pathnameWithSuffix(basePathname, suffix = '') {
  const basePath = basePathname === '/' ? '' : basePathname.replace(/\/+$/, '');
  if (!suffix) {
    return basePath || '/';
  }
  return `${basePath}/${suffix.replace(/^\/+/, '')}`;
}

function toHrefString(url, originalHref) {
  const href = String(originalHref || '').trim();
  if (/^[a-z]+:\/\//i.test(href)) {
    return url.toString();
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

function buildPublicHref(homeHref, { hash = '', suffix = '' } = {}) {
  const url = resolveBaseURL(homeHref);
  url.pathname = pathnameWithSuffix(url.pathname, suffix);
  url.hash = hash ? `#${hash.replace(/^#/, '')}` : '';
  return toHrefString(url, homeHref);
}

export function buildPublicHomeHref(homeHref) {
  return buildPublicHref(homeHref);
}

export function buildPublicLoginHref(homeHref, target = 'student') {
  return buildPublicHref(homeHref, { suffix: authLoginPathForTarget(target) });
}

export function buildPublicSectionHref(homeHref, sectionId) {
  return buildPublicHref(homeHref, { hash: sectionId });
}

export function buildPublicPricingHref(homeHref) {
  return buildPublicSectionHref(homeHref, 'pricing');
}

export function buildPublicTermsHref(homeHref) {
  return buildPublicHref(homeHref, { suffix: 'terms' });
}

export function buildPublicPrivacyHref(homeHref) {
  return buildPublicHref(homeHref, { suffix: 'privacy' });
}

export function buildPublicSupportHref(homeHref) {
  return buildPublicHref(homeHref, { suffix: 'support' });
}
